"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
const supportedJobs = {
    [types_1.Job.ACCOMPAGNEMENT_SCOLAIRE]: {
        activityCategory: 'BNC',
        activityType: '8559B',
        job: 'Accompagnement scolaire dans les établissements',
    },
    [types_1.Job.ARCHITECTE]: {
        activityCategory: 'BNC',
        activityType: '7111Z',
        job: 'Architecte',
    },
    [types_1.Job.CONSEIL_STRATEGIQUE_ENTREPRISE]: {
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil stratégique en entreprise',
    },
    [types_1.Job.CONSULTANT_MARKETING]: {
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Consultant marketing',
    },
    [types_1.Job.DESIGNER]: {
        activityCategory: 'BNC',
        activityType: '7410Z',
        job: 'Designer',
    },
    [types_1.Job.DEVELOPPEUR]: {
        activityCategory: 'BNC',
        activityType: '6201Z',
        job: 'Développeur',
    },
    [types_1.Job.E_COMMERCANT]: {
        activityCategory: 'BIC',
        activityType: '4791B',
        job: 'E-commerçant',
    },
    [types_1.Job.GRAPHISTE]: {
        activityCategory: 'BNC',
        activityType: '7410Z',
        job: 'Graphiste',
    },
    [types_1.Job.LIVREUR_A_VELO]: {
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de repas et de courses à domicile à vélo',
        jobTag: 'BIKER',
    },
    [types_1.Job.SERVEUR]: {
        activityCategory: 'BIC',
        activityType: '5610A',
        job: 'Serveur',
    },
    [types_1.Job.TRADUCTEUR]: {
        activityCategory: 'BNC',
        activityType: '7430Z',
        job: 'Traducteur',
    },
};
exports.default = supportedJobs;
